/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Risk_LimitedInputs */



/**
* | output |
* | --- |
* | "Limited Risk" |
*
* @param {Compliance_Copilot_Risk_LimitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_risk_limited = /** @type {((inputs?: Compliance_Copilot_Risk_LimitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Risk_LimitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Begrenztes Risiko")
	return /** @type {LocalizedString} */ ("Limited Risk")
});